import { CreateElement } from "./element";

interface OptionsBookmark {}

/**
 * Create bookmark
 */
class CreateBookmark extends CreateElement {
    /**
     * Id
     */
    protected id: number;

    /**
     * Name
     */
    protected name: string;

    /**
     * Element options
     */
    protected options: OptionsBookmark;

    /**
     * Constructor
     *
     * @param options - Options bookmark
     * @param id - Id
     * @param name - Name
     */
    constructor(options: OptionsBookmark, id: number, name: string) {
        super();

        this.options = options;
        this.id = id;
        this.name = name;
    }

    /**
     * Creates content
     *
     * @returns Contents
     */
    public create(): string {
        const contents =
            '<w:bookmarkStart w:id="' +
            this.id.toString() +
            '" w:name="' +
            this.name +
            '"/><w:bookmarkEnd w:id="' +
            this.id +
            '"/>';

        return contents;
    }
}

export { CreateBookmark, OptionsBookmark };
